// /client/src/ResponsiveVideoLayout.js

import React, { useEffect, useRef, useState } from "react";
import './VideoLayout.css';
import SimplePersonSilhouette from "./components/SimplePersonSilhouette";

export default function ResponsiveVideoLayout({
  localStream,
  remoteStreams,
  onMuteClick,
  isMuted,
  isCameraOff,
  onCameraClick,
  cameraOffByPeer,
  onToggleLBM,
  isLowBandwidth,
  username,
  socket,
  roomLeader,
  socketIdToUsername,
  socketIdToDisplayName
}) {
  const localVideoRef = useRef(null);
  const remoteVideoRefs = useRef({});
  

  // 🧙‍♂️ Local video tile
const localVideo = (
  <div key="local" className="video-wrapper" style={{ position: "relative" }}>
    {isCameraOff ? (
  <>
    {/* Placeholder overlay (art only) */}
    <div className="placeholder-overlay">
      <div className="placeholder-art">
        <SimplePersonSilhouette className="placeholder-icon" />
      </div>
    </div>

    <div className="display-name">
      {socketIdToDisplayName[socket?.id] ||
        localStorage.getItem("displayName") ||
        username}
    </div>

        {/* New control bar (still available when camera is off) */}
        <div className="control-bar">
          <button
            onClick={onCameraClick}
            className={`control-btn ${isCameraOff ? "active" : ""}`}
            title={isCameraOff ? "Turn camera on" : "Turn camera off"}
          >
            <svg
              viewBox="0 0 24 24"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
              style={{ verticalAlign: "middle" }}
            >
              {isCameraOff ? (
                <>
                  {/* Camera off */}
                  <rect x="3" y="7" width="13" height="10" rx="2" ry="2" />
                  <polygon points="16,9 21,7 21,17 16,15" />
                  <line
                    x1="4"
                    y1="4"
                    x2="20"
                    y2="20"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </>
              ) : (
                <>
                  {/* Camera on */}
                  <rect x="3" y="7" width="13" height="10" rx="2" ry="2" />
                  <polygon points="16,9 21,7 21,17 16,15" />
                </>
              )}
            </svg>
          </button>

          <button
            onClick={onMuteClick}
            className={`control-btn ${isMuted ? "active" : ""}`}
            title={isMuted ? "Unmute" : "Mute"}
          >
            <svg
              viewBox="0 0 24 24"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
              style={{ verticalAlign: "middle" }}
            >
              {isMuted ? (
                <>
                  {/* Muted mic */}
                  <path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3z" />
                  <path d="M19 11a1 1 0 0 0-2 0 5 5 0 0 1-10 0 1 1 0 0 0-2 0 7 7 0 0 0 6 6.92V21h2v-3.08A7 7 0 0 0 19 11z" />
                  <line
                    x1="4"
                    y1="4"
                    x2="20"
                    y2="20"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </>
              ) : (
                <>
                  {/* Live mic */}
                  <path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3z" />
                  <path d="M19 11a1 1 0 0 0-2 0 5 5 0 0 1-10 0 1 1 0 0 0-2 0 7 7 0 0 0 6 6.92V21h2v-3.08A7 7 0 0 0 19 11z" />
                </>
              )}
            </svg>
          </button>

          <button
            onClick={onToggleLBM}
            className={`control-btn ${isLowBandwidth ? "active" : ""}`}
            title="Low Bandwidth Mode"
          >
            LBM
          </button>

        </div>
      </>
    ) : (
      // Normal video tile when camera is on
      <>
        <video
      ref={localVideoRef}
      className="video-tile local"
      playsInline
      autoPlay
      muted
      style={{ visibility: isCameraOff ? "hidden" : "visible" }}
    />

        <div className="display-name">
          {socketIdToDisplayName[socket?.id] ||
            localStorage.getItem("displayName") ||
            username}
        </div>

        {/* New control bar */}
        <div className="control-bar">
          <button
            onClick={onCameraClick}
            className={`control-btn ${isCameraOff ? "active" : ""}`}
            title={isCameraOff ? "Turn camera on" : "Turn camera off"}
          >
            <svg
              viewBox="0 0 24 24"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
              style={{ verticalAlign: "middle" }}
            >
              {isCameraOff ? (
                <>
                  {/* Camera off */}
                  <rect x="3" y="7" width="13" height="10" rx="2" ry="2" />
                  <polygon points="16,9 21,7 21,17 16,15" />
                  <line
                    x1="4"
                    y1="4"
                    x2="20"
                    y2="20"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </>
              ) : (
                <>
                  {/* Camera on */}
                  <rect x="3" y="7" width="13" height="10" rx="2" ry="2" />
                  <polygon points="16,9 21,7 21,17 16,15" />
                </>
              )}
            </svg>
          </button>

          <button
            onClick={onMuteClick}
            className={`control-btn ${isMuted ? "active" : ""}`}
            title={isMuted ? "Unmute" : "Mute"}
          >
            <svg
              viewBox="0 0 24 24"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
              style={{ verticalAlign: "middle" }}
            >
              {isMuted ? (
                <>
                  {/* Muted mic */}
                  <path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3z" />
                  <path d="M19 11a1 1 0 0 0-2 0 5 5 0 0 1-10 0 1 1 0 0 0-2 0 7 7 0 0 0 6 6.92V21h2v-3.08A7 7 0 0 0 19 11z" />
                  <line
                    x1="4"
                    y1="4"
                    x2="20"
                    y2="20"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </>
              ) : (
                <>
                  {/* Live mic */}
                  <path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3z" />
                  <path d="M19 11a1 1 0 0 0-2 0 5 5 0 0 1-10 0 1 1 0 0 0-2 0 7 7 0 0 0 6 6.92V21h2v-3.08A7 7 0 0 0 19 11z" />
                </>
              )}
            </svg>
          </button>

          <button
            onClick={onToggleLBM}
            className={`control-btn ${isLowBandwidth ? "active" : ""}`}
            title="Low Bandwidth Mode"
          >
            LBM
          </button>
        </div>
      </>
    )}
  </div>
);
console.log("isCameraOff in ResponsiveVideoLayout:", isCameraOff);

  // 🧙‍♀️ Remote videos (filtered by live/valid tracks)
  const remoteVideos = Object.entries(remoteStreams)
    .filter(([_, stream]) =>
      stream &&
      stream.active 
    )
    .map(([id, stream]) => {
      if (!remoteVideoRefs.current[id]) {
        remoteVideoRefs.current[id] = React.createRef();
      }

    const isLeader = username === roomLeader;
    const isSelf = socket?.id === id;
    console.log(`🧩 Rendering for ${id}:`, socketIdToDisplayName[id]);
    const remoteCameraOff = !!cameraOffByPeer?.[id];

    const targetUsername = socketIdToUsername[id]; // Lookup
      console.log("🎭 Rendering remote video for:", id);
      if (!targetUsername) {
      console.warn(`⚠️ No username mapped for socket ID: ${id}`);
    }

      return (
  <div key={id} className="video-wrapper" style={{ position: "relative" }}>
    <video
      ref={remoteVideoRefs.current[id]}
      className="video-tile remote"
      playsInline
      autoPlay
    />

    {/* ✅ Remote camera-off placeholder */}
    {remoteCameraOff && (
      <div className="placeholder-overlay">
        <div className="placeholder-art">
          <SimplePersonSilhouette className="placeholder-icon" />
        </div>
      </div>
    )}

    <div className="display-name">
      {socketIdToDisplayName[id] || targetUsername || "Mystery Adventurer"}
    </div>

    {isLeader && !isSelf && targetUsername && (
      <button
        onClick={() => handleKick(targetUsername)}
        title={`Kick ${targetUsername}`}
        style={{
          position: "absolute",
          top: "5px",
          right: "5px",
          backgroundColor: "#8b0000",
          color: "white",
          border: "none",
          borderRadius: "50%",
          width: "30px",
          height: "30px",
          fontWeight: "bold",
          cursor: "pointer",
          boxShadow: "0 0 5px black",
          zIndex: 20, // ✅ keep kick button clickable above overlay
        }}
      >
        ❌
      </button>
    )}
  </div>
);

  });

  const handleKick = async (target) => {
  try {
    const res = await fetch('/api/rooms/kick', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        requester: username,
        target
      })
    });

    const data = await res.json();
    if (!res.ok) {
      alert(`❌ ${data.error}`);
      return;
    }

    alert(`✅ ${data.message}`);
    socket.emit('kick-user', { target });

  } catch (err) {
    console.error("Kick failed:", err);
    alert('⚠️ Failed to kick user.');
  }
};

  // 🧼 Clear out video element srcObject if no stream
  useEffect(() => {
    Object.entries(remoteVideoRefs.current).forEach(([id, ref]) => {
      const stream = remoteStreams[id];
      if ((!stream || stream.getTracks().length === 0) && ref.current) {
        console.log(`🧹 Clearing stale video ref for peer ${id}`);
        ref.current.srcObject = null;
      }
    });
  }, [remoteStreams]);

  // 🗑️ Remove refs to disconnected peers
  useEffect(() => {
    Object.keys(remoteVideoRefs.current).forEach((id) => {
      if (!remoteStreams[id]) {
        delete remoteVideoRefs.current[id];
        console.log(`🗑️ Removed stale video ref for peer ${id}`);
      }
    });
  }, [remoteStreams]);

  // 🎥 Attach local stream
  useEffect(() => {
    if (!isCameraOff && localVideoRef.current && localStream) {
      localVideoRef.current.srcObject = localStream;
      console.log("✅ Assigned local stream to localVideoRef");
    }
  }, [localStream, isCameraOff]);

  // 🎥 Attach remote streams
  useEffect(() => {
    Object.entries(remoteStreams).forEach(([id, stream]) => {
      const ref = remoteVideoRefs.current[id];
      if (ref && ref.current && stream) {
        ref.current.srcObject = stream;
        console.log(`✅ Assigned remote stream ${id}`);
      }
    });
  }, [remoteStreams]);

  // 🧮 Grid class
  const activeRemoteCount = Object.entries(remoteStreams)
    .filter(([_, stream]) => stream && stream.getTracks().length > 0).length;

  const gridSize = 1 + activeRemoteCount;
  let gridClass = "grid-1";
  if (gridSize <= 4) gridClass = `grid-${gridSize}`;
  else if (gridSize <= 9) gridClass = `grid-9`;
  else gridClass = `grid-max`;

  return (
    <div className={`video-grid ${gridClass}`}>
      {localVideo}
      {remoteVideos}
    </div>
  );
}
